export default __webpack_public_path__ + "static/media/xdai.64224e1a.png";